import React from 'react';

import { Badge, ChangeDot, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

export const TopImpactStoryBadge: React.FC<{
	labelTitle: string;
	labelText: string;
	dataTestId: string;
	isCenteredOnMobile: boolean;
	isMobile: boolean;
}> = ({ labelTitle, labelText, dataTestId, isCenteredOnMobile, isMobile }) => {
	return (
		<div className="absolute z-30 w-full -translate-y-1/2">
			<Badge
				data-testid={dataTestId}
				aria-hidden
				className={cn(
					[
						'relative transform cursor-pointer justify-center border px-6 py-2',
						// background-raised and typography-strong are a matched flipping
						// pair (light bg + dark text in light mode, dark bg + light text in
						// dark mode) - the rest-state pill adapts to the theme instead of
						// staying visually fixed.
						'bg-background-raised',
						'border-stroke-weaker text-typography-strong',
						// The hover/press pill (the ::before below) stays a fixed dark-blue
						// gradient in both modes, so its text stays fixed-white to match.
						'group-focus-within:text-typography-inverse-strong-fixed group-hover:text-typography-inverse-strong-fixed',
						'group-hover:duration-t4 group-hover:transition-all',
						// Create pseudo element for the hover state bg
						'before:absolute before:-inset-px before:rounded-full before:content-[""]',
						'before:bg-gradient-background-dark-2',
						// Not using sunrise colors here because designs are using a gradient border
						// which is not supported by the tokens yet
						'before:border-2 before:border-[#0D4DFB]',
						// Animate opacity on group-hover
						'before:duration-t4 before:opacity-0 before:transition-opacity',
					],
					{
						'group-focus-within:before:opacity-100 group-hover:before:opacity-100': !isMobile,
						'text-typography-inverse-strong-fixed before:opacity-100': isCenteredOnMobile,
					},
				)}
				label={
					<div className="relative flex shrink-0 flex-col text-center">
						<div className="flex items-center justify-center gap-1">
							<ChangeDot />
							<Text size="large" className="font-medium">
								{labelTitle}
							</Text>
						</div>

						<Text>{labelText}</Text>
					</div>
				}
			/>
		</div>
	);
};
